const convertProductIdToGraphQL = (id) => `gid://shopify/Product/${id}`;

export default convertProductIdToGraphQL;
